<template>
  <div class="text-xs-center">
    <v-data-table
      :headers="headers"
      :headers-length="headers.length+1"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <data-table-header
        slot="headers"
        slot-scope="props"
        :headers="props.headers"
        :paginacion="paginacion"
      >
        <v-btn
          class="white--text text-xs-center"
          round
          color="primary"
          @click="crear"
        >
          <v-icon
            dark
            small
            class="mr-2"
          >add</v-icon>
          Nuevo

        </v-btn>
      </data-table-header>
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.tipo_archivo.nombre }}</td>
        <td class="text-xs-left">{{ props.item.descripcion  }}</td>
        <td class="text-xs-left"><a
            v-if="props.item.archivo"
            :href="props.item.archivo_url"
            target="_blank"
          >Descargar</a></td>
        <td class="column text-xs-right">
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-0"
            @click="ver(props.item)"
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>

          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-0"
            @click="eliminar(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<!-- SOURCE -->

<script>

import abmListadoMixin from '@/mixins/abmListado'
import { formatoFecha, nombreCentro } from '@/helpers/filtros'
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'PacienteArchivosListado',
  mixins: [abmListadoMixin],

  filters: {
    formatoFecha, nombreCentro
  },
  computed: {
    usuario () {
      return this.$store.getters.getUser
    }
  },
  data: () => ({

    headers: [
      { text: 'Tipo Archivo', value: 'tipoArchivo', sortable: false },
      { text: 'Descripción', value: 'nombre', sortable: false },
      { text: 'Archivo', value: 'archivo', sortable: false }
    ],
    paginacion: { 'descending': true, 'sortBy': 'id' }
  }),
  methods: {
    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.modeloApi.obtenerArchivos(vm.usuario.persona_id, _filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    eliminar (item) {
      let vm = this
      if (confirm('¿Desea eliminar el registro?')) {
        vm.cargando = true
        vm.modeloApi
          .eliminarArchivo(item.id)
          .then(() => {
            Vue.notify({
              group: 'general',
              type: 'success',
              text: 'La operación finalizó correctamente!'
            })
            vm.cargando = false
            vm.filtrar()
          })
          .catch(error => {
            this.$emit('mostrarError', error)
            vm.cargando = false
          })
      }
    }

  }
}
</script>
